import { log } from 'log';
import { realityCheckPopupAction } from 'js/components/popups/RealityCheckPopup';
import { showCoolingOffPopupAction } from 'js/components/popups/CoolingOffPopup';
import { showCommonPopupAction } from 'js/components/common/popups/CommonPopup';

export const actionShowDialogInfo = ({ actionInfo }, { syncClose }) => {
    const { dialogType, dialogId, message, parameters } = actionInfo;

    switch (dialogType) {
        case 'rg:pending-deposit-limits': {
            const data = parameters?.find(item => item.key === '1');

            return showCoolingOffPopupAction({
                id: dialogId,
                content: data?.value ?? message
            });
        }

        case 'rg:rc-timer-expired': {
            const data = parameters?.find(item => item.key === '1')?.value;
            const actionId = parameters?.find(item => item.key === '15')?.value;

            if (data) {
                return realityCheckPopupAction({
                    content: data ?? message,
                    actionId
                });
            }

            break;
        }

        case 'confirmation': {
            const data = parameters?.find(item => item.key === '1')?.value;
            const type = parameters?.find(item => item.key === '11')?.value;
            const actionId = parameters?.find(item => item.key === '15')?.value;

            switch (type) {
                case 'session_summary_notification':
                    return showCommonPopupAction({
                        id: actionId,
                        content: data ?? message,
                        onClose: () => syncClose(actionId)
                    });

                default:
                    break;
            }

            break;
        }

        default:
            break;
    }

    log('error', 'Unsupported actionShowDialogInfo', actionInfo);
    return null;
};
